<template>
  <div class="nps-card" v-if="questions.length">
    <div class="nps-card-title">Evaluación 1-5: {{ questionList }}</div>
    <charts :options="chartOptions"></charts>
  </div>
</template>

<script>
export default {
  name: 'NpsReplicaAttributesSection',
  props: {
    questions: {
      type: Array,
      default: function () {
        return [];
      }
    },
    records: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  computed: {
    questionList () {
      return this.questions.map((item) => item.label).join(', ');
    },
    chartOptions () {
      return {
        chart: {
          type: 'bar',
          height: 220,
          spacing: [0, 0, 0, 0]
        },
        title: {
          text: null
        },
        yAxis: {
          min: 0,
          max: 5,
          title: {
            text: null
          },
          gridLineWidth: 1,
          gridLineColor: '#EEF0F5'
        },
        xAxis: {
          categories: this.questions.map(function (item) {
            return item.label;
          }),
          title: {
            text: null
          }
        },
        credits: {
          enabled: false
        },
        legend: {
          enabled: false
        },
        series: [{
          name: 'Promedio',
          data: this.questions.map((question) => this.averageForQuestion(question.campo)),
          color: '#6366F1'
        }]
      };
    }
  },
  methods: {
    averageForQuestion (field) {
      let sum = 0;
      let count = 0;
      this.records.forEach((record) => {
        const answer = record.answers && record.answers[field] ? record.answers[field] : null;
        if (answer && answer.numeric !== null) {
          sum += answer.numeric;
          count++;
        }
      });

      return count > 0 ? Number((sum / count).toFixed(2)) : 0;
    }
  }
};
</script>

<style scoped>
.nps-card {
  background: var(--bg-card, #FFFFFF);
  border-radius: 12px;
  box-shadow: var(--card-shadow, 0 2px 12px rgba(26,26,46,0.08));
  padding: 20px 22px;
}

.nps-card-title {
  color: var(--text-primary, #1A1A2E);
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/client/rounds/nps-dashboard/components/AttributesSection.vue